<template>
  <div style="background-color: #f0edf1;">
    <div class="box">
      <div style="margin-top: 20px">个人中心&emsp;>&emsp;我的红包</div>
      <div class="content_box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="我发送的" name="first">
            <div class="ct_box">
              <div class="content_child">
                <el-input placeholder="请输入内容" v-model="searchval" style="width: 200px" @blur="search">
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <div>
                  <span>红包类型</span>
                  <el-select v-model="typevalue" placeholder="请选择" @change="change">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" placeholder="全部"></el-option>
                  </el-select>
                </div>
                <div>
                  <span>选择时间：</span>
                  <el-date-picker @change="timechange" v-model="timevalue" value-format="timestamp" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"></el-date-picker>
                </div>
              </div>
              <div class="aside_box">
                <div class="aside_child" v-for="(item, index) in list1" :key="index">
                  <div class="aside_chilada">
                    <div class="aside_img">
                      <img :src="item.user_avatar" />
                      <span style="padding-left: 20px">{{
                        item.alias_name
                      }}</span>
                    </div>
                    <div>
                      {{ item.created_at }}
                    </div>
                  </div>
                  <div style="margin-top: 10px">
                    红包金额：{{ item.money }}元
                  </div>
                  <div style="margin: 10px 0">
                    <span v-show="item.type == 1">红包类型：普通红包</span>
                    <span v-show="item.type == 2">红包类型：贺卡红包</span>
                  </div>
                  <div class="aside_chiladb">
                    <div>
                      <span v-show="item.status == 1">红包状态：未接收</span>
                      <span v-show="item.status == 2">红包状态：已接收</span>
                      <span v-show="item.status == 3">红包状态：已退回</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-size="limit" layout="total,  prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="我收到的" name="second">
            <div class="ct_box">
              <div class="content_child">
                <el-input placeholder="请输入内容" v-model="searchval" style="width: 200px" @blur="searchs">
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <div>
                  <span>红包类型</span>
                  <el-select v-model="typevalue" placeholder="请选择" @change="change">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" placeholder="全部"></el-option>
                  </el-select>
                </div>
                <div>
                  <span>选择时间：</span>
                  <el-date-picker @change="timechange" v-model="timevalue" value-format="timestamp" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"></el-date-picker>
                </div>
              </div>
              <div class="aside_box">
                <div class="aside_child" v-for="(item, index) in list2" :key="index">
                  <div class="aside_chilada">
                    <div class="aside_img">
                      <img :src="item.user_avatar" />
                      <span style="padding-left: 20px">{{
                        item.alias_name
                      }}</span>
                    </div>
                    <div>
                      {{ item.created_at }}
                    </div>
                  </div>
                  <div style="margin-top: 10px">
                    红包金额：{{ item.money }}元
                  </div>
                  <div style="margin: 10px 0">
                    <span v-show="item.type == 1">红包类型：普通红包</span>
                    <span v-show="item.type == 2">红包类型：贺卡红包</span>
                  </div>
                  <div class="aside_chiladb">
                    <div>
                      <span v-show="item.status == 1">红包状态：未接收</span>
                      <span v-show="item.status == 2">红包状态：已接收</span>
                      <span v-show="item.status == 3">红包状态：已退回</span>
                    </div>
                    <div class="btn" v-show="item.status == 1" @click="linqu(item.redpack_id)">
                      立即接收
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-size="limit" layout="total,  prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { redpackList, redpackdraw } from "../../api/apply/index";
export default {
  data () {
    return {
      activeName: "first",
      searchval: "",
      typevalue: "",
      timevalue: "",
      options: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "普通",
        },
        {
          value: "2",
          label: "贺卡",
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      timestart: "",
      timeend: "",
      limit: 6,
      page: 1,
      total: 0,
      list1: [],
      list2: [],
      i: "",
    };
  },
  created () {
    this.getlist1();
  },
  mounted () { },
  methods: {
    //搜索
    search () {
      let data = {
        keyword: this.searchval,
        type: 1,
        status: this.typevalue,
        start_time: this.timestart,
        end_time: this.timeend,
        limit: this.limit,
        page: this.page,
      };
      redpackList(data).then((res) => {
        this.list1 = res.data.data;
        this.total = res.data.total;
      });
    },
    searchs () {
      let data = {
        keyword: this.searchval,
        type: 2,
        status: this.typevalue,
        start_time: this.timestart,
        end_time: this.timeend,
        limit: this.limit,
        page: this.page,
      };
      redpackList(data).then((res) => {
        this.list2 = res.data.data;
        this.total = res.data.total;
      });
    },
    //红包领取
    linqu (id) {
      redpackdraw({ redpack_id: id }).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "领取成功",
          });
          this.getlist2();
        } else {
          this.$message({
            type: "success",
            message: res.msg,
          });
        }
      });
    },
    //红包记录分页
    handleSizeChange (val) {
      this.limit = val;
      if (this.i == 0) {
        this.getlist1();
      }
      if (this.i == 1) {
        this.getlist2();
      }
    },
    handleCurrentChange (val) {
      this.page = val;
      if (this.i == 0) {
        this.getlist1();
      }
      if (this.i == 1) {
        this.getlist2();
      }
    },
    //我发送的红包
    getlist1 () {
      let data = {
        type: 1,
        status: this.typevalue,
        start_time: this.timestart,
        end_time: this.timeend,
        limit: this.limit,
        page: this.page,
      };
      redpackList(data).then((res) => {
        this.list1 = res.data.data;
        this.total = res.data.total;
      });
    },
    //我接受的红包
    getlist2 () {
      let data = {
        type: 2,
        status: this.typevalue,
        start_time: this.timestart,
        end_time: this.timeend,
        limit: this.limit,
        page: this.page,
      };
      redpackList(data).then((res) => {
        this.list2 = res.data.data;
        this.total = res.data.total;
      });
    },
    //选择时间
    timechange (e) {
      this.timestart = e[0] / 1000;
      this.timeend = e[1] / 1000;
    },
    //选择红包类型
    change (e) { },
    handleClick (e, event) {
      this.i = e.index;
      this.page = 1;
      this.searchval = ''
      this.typevalue = ''
      this.timevalue = ''
      if (e.index == 0) {
        this.getlist1();
      }
      if (e.index == 1) {
        this.getlist2();
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.box {
  width: 1200px;
  margin: auto;
  .content_box {
    .bottom {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
    }
    height: 600px;
    margin: 20px 0;
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    .content_child {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .aside_box {
      display: flex;
      flex-wrap: wrap;
      .aside_child {
        width: 27.5%;
        border-radius: 8px;
        border: 1px solid #ccc;
        padding: 20px;
        margin: 10px;
        .aside_chilada {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .aside_img {
            display: flex;
            align-items: center;
            img {
              width: 50px;
              height: 50px;
              border-radius: 8px;
            }
          }
        }
        .aside_chiladb {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .btn {
            text-align: center;
            line-height: 30px;
            width: 100px;
            height: 30px;
            color: white;
            border-radius: 10px;
            background-color: #4a72d9;
          }
        }
      }
    }
  }
}
</style>
